module.exports = __webpack_public_path__ + "media/assets/images/flags/ht-58be42765101832a8ace5e9e329a46ee.svg";